import { useMemo, useCallback } from 'react';

const useInfiniteScroll = ({ infiniteScroll, tableData, isLoading, }) => {
    const addRowForInfiniteScrollIndicator = Boolean(infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.hasMore);
    const modifiedTableData = useMemo(() => {
        if (!isLoading && addRowForInfiniteScrollIndicator) {
            return [
                ...tableData,
                {
                    id: 'loading-indicator',
                    __loading: true,
                },
            ];
        }
        return tableData;
    }, [isLoading, tableData, addRowForInfiniteScrollIndicator]);
    const modifiedTableDataLength = modifiedTableData.length;
    const onItemsRendered = useCallback(({ visibleStopIndex }) => {
        const isLastRowVisible = visibleStopIndex === modifiedTableDataLength - 1;
        if (infiniteScroll && isLastRowVisible && infiniteScroll.hasMore && !infiniteScroll.isFetching) {
            infiniteScroll.fetchMore();
        }
    }, [infiniteScroll, modifiedTableDataLength]);
    return {
        modifiedTableData,
        onItemsRendered: infiniteScroll ? onItemsRendered : undefined,
    };
};

export { useInfiniteScroll as default, useInfiniteScroll };
//# sourceMappingURL=useInfiniteScroll.js.map
